.header {
  margin: 13px 0 30px;
}

.primaryFormActions {
  display: flex;
  justify-content: flex-end;
  div {
    margin-left: 10px;
  }
}
